import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaLinkedinIn, FaTwitter, FaFacebook } from "react-icons/fa";
import { HiOutlineMail, HiOutlinePhone, HiOutlineUser } from "react-icons/hi";
import footer1 from "../../assets/images/landingpage/footer1.webp";
import footer2 from "../../assets/images/landingpage/footer2.webp";
import { useEffect } from "react";
import { findSocialMedia } from "../../api/commonApi";

const Footer = () => {
  const [socialmedia, setSocialMedia] = useState({})
  const fetchmediaContent = async () => {
    try {
      const response = await findSocialMedia();
      const raw = response?.data;
      setSocialMedia(raw)
      console.log('mediadata', raw)
    } catch (error) {
      console.error("Error loading terms and conditions:", error);
    }
  };
  useEffect(() => {
    fetchmediaContent()
  }, [])
  return (
    <footer className="bg-[#87004C] text-white py-10">
      <div className="container mx-auto px-6 md:flex md:justify-between md:items-start space-y-8 md:space-y-0">
        <div className="space-y-4">
          <h2 className="bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] bg-clip-text text-transparent text-3xl font-bold">
            AVITA
          </h2>

          <p className="tracking-widest text-sm">RESIDENCES</p>
          <div className="flex space-x-3">
            {socialmedia?.instagram && (
              <a
                href={socialmedia?.instagram}
                target="_blank"
                className="bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] text-[#8C1D40] p-2 rounded-full font-medium"
              >
                <FaInstagram size={16} />
              </a>
            )}
            {socialmedia?.linkedIn && (
              <a
                href={socialmedia?.linkedIn}
                target="_blank"
                className="bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] text-[#8C1D40] p-2 rounded-full font-medium"
              >
                <FaLinkedinIn size={16} />
              </a>
            )}
            {socialmedia?.facebook && (
              <a
                href={socialmedia?.facebook}
                target="_blank"
                className="bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] text-[#8C1D40] p-2 rounded-full font-medium"
              >
                <FaFacebook size={16} />
              </a>
            )}
            {socialmedia?.twitter && (
              <a
                href={socialmedia?.twitter}
                target="_blank"
                className="bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] text-[#8C1D40] p-2 rounded-full font-medium"
              >
                <FaTwitter size={16} />
              </a>
            )}
            {/* <a
              href="#"
              className="bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] text-[#8C1D40] p-2 rounded-full font-medium"
            >
              <FaFacebookF size={16} />
            </a> */}
          </div>
        </div>
        <div className="flex flex-col items-center space-y-4">
          <div className="flex space-x-3">
            <img src={footer1} alt="Google Play" className="h-10" />
            <img src={footer2} alt="App Store" className="h-10" />
          </div>
          <div className="flex space-x-6 text-sm">
            <Link to="/termsandcondition" className="hover:underline " onClick={() => window.scrollTo(0, 0)}>Terms and Conditions</Link>
            <Link to="/privacypolicy" className="hover:underline " onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link>
            <Link to="/RefundPolicy" className="hover:underline" onClick={() => window.scrollTo(0, 0)}>Refund Policy</Link>
          </div>
        </div>
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <HiOutlineUser className="text-yellow-300" size={20} />
           <p className="">Saravanan Subiramaniam</p>
          </div>
          <div className="flex items-center space-x-2">
            <HiOutlineMail className="text-yellow-300" size={20} />
            <a href={`mailto:${socialmedia?.emailId}`}>
              {socialmedia?.emailId}
            </a>

          </div>
          <div className="flex items-center space-x-2">
            <HiOutlinePhone className="text-yellow-300" size={20} />
            <div>
              <p>+91{socialmedia?.phoneNumber1}</p>
              <p>+91{socialmedia?.phoneNumber2}</p>
              <p>+91{socialmedia?.phoneNumber3}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/30 mt-8  pt-4">
        <p className="text-center text-sm">
          ©2026 Avita. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
